/** Approved website presentation. Subscription entitlements remain managed separately. */
export function pricingFeatures(_id: string, features: string[]) {
  const content = features
    .filter(
      (feature) =>
        !/support/i.test(feature) && feature !== 'Advanced AI models',
    )
    .map((feature) => {
      if (/analytics/i.test(feature)) return 'Analytics';
      if (feature === '3,000 credits per month') return '3k credits per month';
      if (feature === '9,000 credits per month') return '9k credits per month';
      if (feature === '25,000 credits per month')
        return '25k credits per month';
      return feature;
    });
  return content;
}
export function pricingFeatureLabel(feature: string) {
  if (feature === '2 AI agents') return '+1 AI agent (2 total)';
  if (feature === '3 AI agents') return '+1 AI agent (3 total)';
  if (feature.startsWith('5+ seats'))
    return '5+ seats total · extra seats at additional cost';
  if (/^\d[\d,]* (AI agents?|credits per month|seats?)$/.test(feature))
    return `${feature} total`;
  return feature;
}
export function pricingSupport(id: string) {
  return id === 'free'
    ? 'No email support'
    : id === 'pro'
      ? 'Priority email support'
      : 'Email support';
}
